import {Tr} from "@/i18n/i18n";
import {VerticalStandardPanel} from "@/scenes.ui/vertical-standard-panel";
import {Keys} from "@/constants/key";
import {HallOptionInfo} from "@/store/clan/types";
import SpriteUtils from "@/utils/sprite-utils";
import {CreatureUtils} from "@/utils/creature-utils";
import {WarriorClass} from "@/store/level/types";
import {ForceUtils} from "@/utils/force-utils";
import TextUtils from "@/utils/text-utils";
import {Fonts} from "@/constants/font";
import ClanStore from "@/store/clan";
import {FeedbackPanel} from "@/scenes.ui/feedback-panel";
import PriceWithGearsPanel from "@/scenes.ui/price-with-gears-panel";
import CU from "@/utils/c-u";
import Scene = Phaser.Scene;

export class ClanHallPanel extends VerticalStandardPanel {

    constructor(scene: Scene, canvas: HTMLCanvasElement,options: HallOptionInfo[], canStartBuilding:boolean, buildCallback: (gearsLeft: number)=> void) {
        super(scene, canvas, Tr('improve.creature.classes'));
        const back = SpriteUtils.addImage(this.scene, 0, 55, Keys.ATLAS_SHOP_UI, Keys.UI_SHOP_PANEL_BACK, 1, -2).setOrigin(0.5, 1);
        const back2 = SpriteUtils.addImage(this.scene, 0, 55, Keys.ATLAS_SHOP_UI, Keys.UI_SHOP_PANEL_BACK, 1, 2).setOrigin(0.5, 1);
        let sep = SpriteUtils.addSprite(this.scene, 0,  -300, Keys.ATLAS_SHOP_UI, Keys.UI_SHOP_SEPARATOR_LARGE, 1, 1).setOrigin(0.5);
        let sep2 = SpriteUtils.addSprite(this.scene, 0,  +410, Keys.ATLAS_SHOP_UI, Keys.UI_SHOP_SEPARATOR_LARGE, 1, 1).setOrigin(0.5);
        this.add(sep);
        this.add(sep2);
        this.add(back);
        this.add(back2);
        this.sendToBack(sep);
        this.sendToBack(sep2);
        this.sendToBack(back);
        this.sendToBack(back2);
        this.sendToBack(this.window)
        this.sendToBack(this.background)

        this.xButton.setScale(0.8)
        this.xButton.y+= 7;


        this.title.visible = false;


        let titleText = TextUtils.addTextAdvanced(scene, Tr('improve.creature.classes').toUpperCase(), 0, -280,
            '#ffd747', 15, 'normal', 480, 'center', 2, Fonts.BENGALY_NORMAL).setOrigin(0.5);
        this.add(titleText);

        let sep3 = SpriteUtils.addSprite(this.scene, 0, titleText.y / CU.S + 15, Keys.ATLAS_SHOP_UI, Keys.UI_SHOP_SEPARATOR, 0.5, 0.4);
        this.add(sep3);

        let self = this;
        this.y += 55;

        let optionsInRow = 4;

        let dx = 140;
        let x0 = -1.5* dx;
        let y0 = -158;
        let dy = 195;

        let index = 0;
        for( let i=0; i<options.length/optionsInRow; i++){
            for( let j=0; j<optionsInRow && index < options.length; j++) {

                let option = options[index];
                let force = option.force;

                let forceName = TextUtils.addTextAdvanced(scene, CreatureUtils.getClassName(force), x0 + j*dx, y0 + i*dy - 90,
                    '#a2ff82', 13, 'normal', 400, 'center', 2, Fonts.ARIAL_MT);

                let forceProgress = TextUtils.addTextAdvanced(scene, "" + option.level + " " + Tr('of') + " " + option.maxLevel,
                    x0 + j*dx, y0 + i*dy - 70, '#ffffff', 12, 'normal', 400, 'center', 2, Fonts.ARIAL_MT);

                let forceValue = TextUtils.addTextAdvanced(scene, Tr('ataka') + " +" + Math.round(option.value * 100) + "%",
                    x0 + j*dx, y0 + i*dy - 50, '#e1af23', 12, 'normal', 400, 'center', 2, Fonts.ARIAL_MT);

                let forceIcon = SpriteUtils.addSprite(scene, x0 + j*dx, y0 + i*dy-10,
                    CreatureUtils.getForceAtlasLarge(force), CreatureUtils.getLargeForceIcon(force, true), 0.6, 0.6);

                let ddy = -20;

                let pricePanel = new PriceWithGearsPanel(scene, (x0 + j*dx+15) * CU.S, (y0 + i*dy + 70 + ddy) * CU.S, option.price);

                let canImprove = option.level < option.maxLevel;

                let improveButton = SpriteUtils.addSprite(scene, x0 + j*dx, y0 + i*dy + 84 + ddy,
                    Keys.CL_SMALL_RED_BUTTON, undefined,0.8, 0.8);
                improveButton.visible = canStartBuilding && canImprove;

                improveButton.setInteractive().on('pointerup', function() {
                    ClanStore.makeForceImprovement(force, option.level + 1).then(gearsLeft=>{
                        new FeedbackPanel(self.scene, Tr('sila.uluchshena'), undefined, true).show();
                        ClanStore.fetchHallUpgradeOptions().then((options: HallOptionInfo[]) => {
                            buildCallback(gearsLeft.valueOf());
                            let clanHallPanel: ClanHallPanel = new ClanHallPanel(self.scene, self.canvas, options, canStartBuilding, buildCallback);
                            clanHallPanel.open();
                            self.closeWithoutAnimation();
                        });

                    }).catch(
                        (error) => {
                            new FeedbackPanel(self.scene, Tr('u.klana.nedostatochno.sredstv'), undefined, false).show();
                        }
                    );
                })

                let improveWordString = canStartBuilding? Tr('imp') + " +" + Math.round(option.delta * 100) + "%" :
                    " +" + Math.round(option.delta * 100) + "% " + Tr('p.lev');
                let improveWord = TextUtils.addTextAdvanced(scene, improveWordString,
                    x0 + j*dx, y0 + i*dy + 84 + ddy, '#ffffff', 10, 'normal', 400, 'center', 2, Fonts.ARIAL_MT);
                improveWord.visible = canImprove;

                this.add([forceIcon, forceName, forceProgress, pricePanel, improveButton, improveWord, forceValue])
                index ++;
            }
        }

    }

    public doOpenAnimated(del: number, dur: number): void {
        this.open();
        this.setAlpha(0);
        this.setScale(0.92);

        this.scene!.tweens.add({
            targets: this,
            alpha: 1,
            scale: 1,
            delay: del,
            duration: dur
        });

    }
}
